import {
  ObalMaterialInitData,
  ObalMaterialNrSrInitData,
  ObalMaterialInitDataApi,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ObalMaterialu } from '../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuFormData';
import { ObalMaterialuNrSr } from '../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';
import { ObalMaterialuNrSrBezchybnostFormData } from '../../../model/pracovnyKrok/ObalMaterialuNrSrBezchybnostFormData';
import Uuid from '../../../model/Uuid';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';

const client = new ObalMaterialInitDataApi(apiConfiguration(elegislativaPrefixPath));

const mapVseobecny = (data: ObalMaterialInitData): ObalMaterialu => ({
  predkladatel: data.predkladatel,
  miestoDatum: data.miestoDatum,
  navrh: data.navrh,
  nazovMaterialu: data.nazovMaterialu,
  podnet: data.podnet,
  zodpovednaInstitucia: data.zodpovednaInstitucia,
  rok: data.rok,
  nazovVygenerovanehoDokumentu: data.nazovVygenerovanehoDokumentu,
  obsahMaterialu: data.obsahMaterialu,
  rezortneCislo: data.rezortneCislo,
  typMaterialu: data.typMaterialu,
  typObalu: data.typObalu,
});

const mapNrSr = (data: ObalMaterialNrSrInitData): ObalMaterialuNrSr => ({
  predkladatel: data.predkladatel,
  miestoDatum: data.miestoDatum,
  nazovMaterialu: data.nazovMaterialu,
  rezortneCislo: data.rezortneCislo,
  typMaterialu: data.typMaterialu,
  cisloParlamentnejTlace: data.cisloParlamentnejTlace,
  navrhUznesenia: data.navrhUznesenia,
  vladnyNavrh: data.vladnyNavrh,
});

const mapNrSrZaBezchybnost = (data: ObalMaterialNrSrInitData): ObalMaterialuNrSrBezchybnostFormData => ({
  zaBezchybnost: data.zaBezchybnost,
  zodpovednyPredkladatel: data.zodpovednyPredkladatel,
  predkladatel: data.predkladatel,
  miestoDatum: data.miestoDatum,
  nazovMaterialu: data.nazovMaterialu,
  rezortneCislo: data.rezortneCislo,
  typMaterialu: data.typMaterialu,
  cisloParlamentnejTlace: data.cisloParlamentnejTlace,
  navrhUznesenia: data.navrhUznesenia,
  vladnyNavrh: data.vladnyNavrh,
});

export const fetchObalMaterialuVseobecnyInitData = async (
  type: string,
  year: number,
  index: number,
  stadiumUuid: Uuid,
  stadium: StadiumMaterialuEnum,
  headers?: object,
):
  Promise<ClientResponse<ObalMaterialu>> => {
  const {
    data,
    status,
  } = await client.getInitialDataForObalMaterialuVseobecny(type, year, index, stadiumUuid, stadium, headers);
  return {
    data: mapVseobecny(data),
    responseCode: status,
  };
};

export const fetchObalMaterialuNrSrInitData = async (
  type: string,
  year: number,
  index: number,
  headers?: object,
):
  Promise<ClientResponse<ObalMaterialuNrSr>> => {
  const {
    data,
    status,
  } = await client.getInitialDataForObalMaterialuNrSr(type, year, index, headers);
  return {
    data: mapNrSr(data),
    responseCode: status,
  };
};

export const fetchObalMaterialuNrSrZaBezchybnostInitData = async (
  type: string,
  year: number,
  index: number,
  headers?: object,
):
  Promise<ClientResponse<ObalMaterialuNrSrBezchybnostFormData>> => {
  const {
    data,
    status,
  } = await client.getInitialDataForObalMaterialuNrSr(type, year, index, headers);
  return {
    data: mapNrSrZaBezchybnost(data),
    responseCode: status,
  };
};
